/* eslint-disable import/order */
import { useEffect, useRef, useState } from 'react';
import { Typography, MaterialIcons, LayoutHerodias } from '@lux/ds';
import { NavButton, NavIconWrapper, NavTag, StyledNavItem } from './NavItem.styles';
import NavSubMenuItem from './NavSubMenuItem';
import { StyledPopover, PopoverContent } from './Popover';
import { IProductModule } from '../../../configs/Products.types';

interface INavItemProps {
  baseUrl?: string;
  isNew?: boolean;
  open: boolean;
  title: string;
  popoverTitle?: string;
  icon: JSX.Element;
  modules: IProductModule[];
  selected?: boolean;
}

const NavItem: React.FC<INavItemProps> = ({
  baseUrl,
  isNew,
  open,
  title,
  popoverTitle,
  selected,
  modules,
  icon,
}) => {
  const wrapperRef = useRef(null);
  const [_internalOpen, _setInternalOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      _setInternalOpen(open);
    }
  }, [open]);

  return (
    <StyledNavItem $selected={selected} ref={wrapperRef}>
      <NavButton
        onClick={() => _setInternalOpen(!_internalOpen)}
        open={open}
        active={_internalOpen}
      >
        <NavIconWrapper $isNew={isNew}>{icon}</NavIconWrapper>
        <LayoutHerodias gap="xs">
          <Typography
            variant="bodyTextNormal"
            weight="semibold"
            color={selected ? 'primary.light' : 'primary.shade.40'}
            style={{ flex: 1, textAlign: 'left' }}
          >
            {title}
          </Typography>
          {isNew ? <NavTag size="small" label="New version" squared /> : null}
        </LayoutHerodias>
        {_internalOpen ? <MaterialIcons.KeyboardArrowUp /> : <MaterialIcons.KeyboardArrowDown />}
      </NavButton>
      <StyledPopover
        open={_internalOpen && !open}
        anchorEl={wrapperRef?.current || null}
        onClose={() => _setInternalOpen(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <PopoverContent>
          <LayoutHerodias gap="xs">
            <Typography variant="bodyTextNormal" weight="bold" color="primary.light">
              {popoverTitle || title}
            </Typography>
            {isNew ? <NavTag size="small" label="New version" squared /> : null}
          </LayoutHerodias>
          {modules.map(props => (
            <NavSubMenuItem
              key={props.path}
              {...props}
              baseUrl={baseUrl}
              closeMenu={() => _setInternalOpen(false)}
              mainSelected={selected}
            />
          ))}
        </PopoverContent>
      </StyledPopover>
      {_internalOpen && open && (
        <div className="expanded-menu-items">
          {modules.map(props => (
            <NavSubMenuItem
              key={props.path}
              {...props}
              baseUrl={baseUrl}
              closeMenu={() => _setInternalOpen(false)}
              margin
              mainSelected={selected}
            />
          ))}
        </div>
      )}
    </StyledNavItem>
  );
};

export default NavItem;
